function track(...args: [string, ...any[]]) {
    if (window.umami?.track && window.umami.track instanceof Function && window.ENVIRONMENT_NAME !== 'development') {
        window.umami.track(...args);
    }
}

function identify(userId: string) {
    if (
        userId != null &&
        window.umami?.identify &&
        window.umami.identify instanceof Function &&
        window.ENVIRONMENT_NAME !== 'development'
    ) {
        window.umami.identify(userId);
    }
}

export { track, identify };
